'use client'

import { useEffect, useState } from 'react';
import SignedInMyListButton from '@/components/Button/MyList/SignedInMyListButton'
import SignedOutMyListButton from '@/components/Button/MyList/SignedOutMyListButton'
import MyListButtonProps from '@/components/Button/MyList/MyListTypes';
import { useIdentity } from '@/lib/hooks/useIdentity';

const MyListButton = (props: MyListButtonProps) => {
  const { isAuthenticated } = useIdentity()
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  if(isClient) {
    if(isAuthenticated) {
      return <SignedInMyListButton {...props} />
    } else {
      return <SignedOutMyListButton {...props} />
    }
  }

  return <></>
}

export default MyListButton
